import React from 'react';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { SignInEmptyDiv } from '../component/sign-in-empty/SignInEmptyDiv';

export const SignInEmptyPage = () => (
  <SignInPageLayout centerDesktop={<SignInEmptyDiv />} />
);
